import clsx from 'clsx'

import { ChildProps } from '@/common/util/props'

interface Props extends ChildProps {
  gapX?: 4 | 8 | 12 | 16
  gapY?: 0 | 4 | 8 | 16
  direction?: 'horizon' | 'vertical'
  align?: 'start' | 'center'
  nowrap?: boolean
}

const FormAlign = ({
  children,
  gapX = 8,
  gapY = 0,
  direction,
  align = 'center',
  nowrap = false
}: Props) => {
  const gapXClass = gapX && gapX / 4
  const gapYClass = gapY && gapY / 4
  return (
    <>
      <div
        className={clsx(
          'flex w-full max-w-full',
          `gap-x-${gapXClass}`,
          direction == 'vertical' && 'flex-col',
          `items-${align}`,
          nowrap ? 'flex-nowrap' : 'flex-wrap',
          gapY && `gap-y-${gapYClass}`
        )}
      >
        {children}
      </div>
    </>
  )
}

export default FormAlign
